//========================================================================================
/*

  data          [arr]
  valueField    [str]
  textField     [str]
  dropUp        [bool]
  
 */
//========================================================================================

import { InputLabel, Required } from 'styles/common';
import { Dropdown, ErrorMessage, DropdownBlock } from './styles';
import { translate } from 'react-i18next';

export default translate()(
  ({
    open,
    className,
    i18n,
    input = {},
    filter,
    data,
    valueField,
    textField,
    defaultValue,
    dropUp,
    onSearch,
    style,
    messages,
    label,
    onChange,
    placeholder,
    isRequired,
    itemComponent,
    valueComponent,
    searchTerm,
    value,
    meta: { touched, error } = {},
    onToggle,
    onSelect
  }) => (
    <DropdownBlock className={`${className || 'select-field-wrapper'}`} >
      <InputLabel className="input-label">
        {label}
        {isRequired && <Required> *</Required>}
      </InputLabel>

      <Dropdown
        {...input}
        style={style}
        filter={filter}
        data={data}
        open={open}
        value={value}
        itemComponent={itemComponent}
        valueComponent={valueComponent}
        defaultValue={defaultValue}
        dropUp={dropUp}
        valueField={valueField}
        textField={textField}
        onChange={input.onChange || onChange}
        onToggle={onToggle}
        onSelect={onSelect}
        onSearch={onSearch}
        placeholder={placeholder}
        searchTerm={searchTerm}
        messages={messages}
        error={error && touched}
      />

      {touched &&
          error && (
        <ErrorMessage>
          {typeof error === 'string' && i18n.t(error)}
        </ErrorMessage>
      )}
    </ DropdownBlock>
  )
);
